export default __webpack_public_path__ + "static/media/lotteryImg@2x.56c1416a.png";